var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.249 23.625C20.249 21.2381 19.3008 18.9489 17.613 17.261C15.9252 15.5732 13.636 14.625 11.249 14.625C8.86208 14.625 6.57289 15.5732 4.88506 17.261C3.19724 18.9489 2.24902 21.2381 2.24902 23.625",
    stroke: "black",
    strokeWidth: 1.67553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.249 14.625C14.3556 14.625 16.874 12.1066 16.874 9C16.874 5.8934 14.3556 3.375 11.249 3.375C8.14242 3.375 5.62402 5.8934 5.62402 9C5.62402 12.1066 8.14242 14.625 11.249 14.625Z",
    stroke: "black",
    strokeWidth: 1.67553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7484 22.5001C24.7484 18.7088 22.4984 15.1876 20.2484 13.5001C20.988 12.9452 21.5794 12.2166 21.9703 11.3786C22.3612 10.5407 22.5395 9.61937 22.4895 8.69612C22.4394 7.77287 22.1625 6.87619 21.6833 6.08545C21.2042 5.2947 20.5374 4.63427 19.7422 4.1626",
    stroke: "black",
    strokeWidth: 1.67553,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ea104f12e2017b47e91d92936d681d8c.svg";
export { ForwardRef as ReactComponent };